import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  position: string | null;
  phone: string | null;
  avatar_url: string | null;
  business_name: string | null;
  business_service: string | null;
  business_website: string | null;
  business_phone: string | null;
  business_logo_url: string | null;
  role: 'admin' | 'crew' | 'client';
  created_at: string;
  updated_at: string;
};

export type Event = {
  id: string;
  name: string;
  start_date: string | null;
  end_date: string | null;
  timezone: string;
  venues: string | null;
  objectives: string | null;
  critical_notes: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
};

export type ScheduleEntry = {
  id: string;
  event_id: string;
  title: string;
  entry_type: 'load_in' | 'rehearsal' | 'show' | 'dark_day' | 'load_out';
  start_datetime: string;
  end_datetime: string | null;
  call_time: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
};

export type CrewMember = {
  id: string;
  event_id: string;
  full_name: string;
  role: string;
  phone: string | null;
  email: string | null;
  call_time: string | null;
  travel_days: string | null;
  emergency_contact: string | null;
  emergency_phone: string | null;
  created_at: string;
  updated_at: string;
};

export type FileRecord = {
  id: string;
  event_id: string;
  section: string;
  section_item_id: string | null;
  filename: string;
  file_path: string;
  file_size: number | null;
  file_type: string | null;
  version: number;
  is_latest: boolean;
  uploaded_by: string;
  created_at: string;
};

export type ChangeLogEntry = {
  id: string;
  event_id: string;
  section: string;
  change_description: string;
  changed_by: string;
  created_at: string;
};
